// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "element-ui/lib/theme-chalk/index.css";
import Element from 'element-ui'
import './assets/theme/index.css'
import './assets/iconfont/iconfont.css'
import axios from 'axios'
import store from './store'
import util from './util'
import cookie from './util/cookie'
import filter from './filter'
import './components/MyUpload'
import echarts from 'echarts'
Vue.use(Element)

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;
axios.defaults.headers.statusMark = 'SP';

router.beforeEach((to, from, next) => {

    clearInterval(window['invitePriceInfoTimer']);

    if (util.isPublicRoute(to.name)) {
        next()
    } else {
        if (window.sessionStorage.getItem('stockId')) {
            next()
        } else {
            Vue.prototype.$alert('登录超时，请重新登录！', util.alertTitle, {
                callback: action => {
                    next({
                        path: '/login',
                        query: { redirect: to.fullPath }
                    })
                }
            })
        }

    }

})

Vue.prototype.$echarts = echarts

Vue.prototype.$http = axios.create({
    baseURL: util.baseUrl,
    headers: {'Content-Type':'application/json'}
})
Vue.prototype.$http.interceptors.request.use( config => {
    // 在发送请求之前做些什么
    config.headers.AuthorizationToken = window.sessionStorage.getItem('AuthorizationToken')
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
})
Vue.prototype.$http.interceptors.response.use(res => {// 响应成功
    if(!util.isPublicRoute(app.$route.name) && ~(res.data.message||'').indexOf('未登录')){
        app.$router.push(`/login?msg=${res.data.message}&redirect=${app.$route.fullPath}`)
    }
    return res
}, error => {
    alert('加载失败')
    return Promise.reject(error)
})
/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App },
    filters: filter,
    data: {
        loading: false,
        userId: '',//待办消息的获取还是需要的
        stockId:'',//现在先放个stockId表示一下
        navs:[], // 导航：{name:显示名称,path:跳转地址}
        headImage:{src:'',width:'100%',height:'auto'},//背景图
        activeIndex: 'home', // 标记选中的菜单
        alertTitle: util.alertTitle,
        auditStep: 1, //资料审核
        isPublic: true,//用于切换顶部菜单
        env: util.buildEnv,
        loginUserType: '',
    },
    methods:{
        logout(){
            this.$http.get('/rest/api/dspUserApi/logout').then((res)=>{
                if(res.data.result) {
                    window.sessionStorage.removeItem('userId');
                    window.sessionStorage.removeItem('stockId');
                    window.sessionStorage.removeItem('auditStep');
                    this.userId = '';
                    this.stockId = '';
                    this.$store.dispatch('removeCaches');
                    this.$router.push('/login');
                }
            } , err => {
                this.$root.loading = false;
                this.$alert(err)
            });
            //this.$alert('登出成功！', this.alertTitle, {
            //    callback: action => {

            //    }
            //})
        },
        getNodeInfo (nodeName) {
            if (!!nodeName) {
                this.$alert(`该单据最新OA审批流程正处于（${nodeName}）节点，请耐心等待！`)
            } else {
                this.$alert('未能查到该单据的OA审批节点信息（可能是2019年7月中旬之前的数据，或该单据只是传递给EAS还未发起OA审批））！')
            }
        }
    },
    created(){
        this.userId = window.sessionStorage.getItem('userId');
        this.stockId = window.sessionStorage.getItem('stockId');
        this.auditStep = +window.sessionStorage.getItem('auditStep')||1;

        this.loginUserType = window.sessionStorage.getItem('loginUserType');
        console.log('isPublic----' + this.isPublic)
        console.log('loginUserType----' + this.loginUserType)
    }
})

export default app



// WEBPACK FOOTER //
// ./src/main.js